export const environment = {
  production: false,
  awsEndpointUrl: {
    baseURL: 'https://api.sandbox.vodp.s.joyn.de',
  },
  playerBaseUrl: 'https://apps.accurate.video',
  isAudioLayoutVisible: true,
  pia: {
    authority: 'https://login.p7s1.io/auth/realms/pia',
    clientId: 'torch-ui',
    scope: 'openid',
    redirectPath: '/auth/callback',
  },
}
